// import React from 'react';

// class Hubspot extends React.Component {
//   componentDidMount () {
//     const script = document.createElement("script");
//     script.async = true;
//     script.defer = true;
//     script.type = 'text/javascript';
//     script.id = 'hs-script-loader';
//     script.src = '//js.hs-scripts.com/20904955.js'; // production site-id

//     // <!-- Start of HubSpot Embed Code -->
//     // <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/20904955.js"></script>
//     // <!-- End of HubSpot Embed Code -->

//     document.head.appendChild(script);
//     // this.instance.appendChild(script);
//   }

//   render() {
//     return (<></>);
//   }
// }

// export default Hubspot;

import React from 'react';

class Hubspot extends React.Component {
  componentDidMount () {
    const injectHubspot = () => {
      if (!document.getElementById('hs-script-loader')) {
        // console.log('Injecting HubSpot script');
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.type = 'text/javascript';
        script.id = 'hs-script-loader';
        script.src = '//js.hs-scripts.com/20904955.js'; // production site-id
        document.head.appendChild(script);
      }
    };

    // Always listen for consent events
    const handleConsentAccept = (event) => {
      if (event && event.detail) {
        // Check if user actually accepted consent based on updatedBy field
        if (event.detail.consent.updatedBy === 'onAcceptAllServices' || 
            event.detail.consent.updatedBy === 'onAcceptAll' ||
            event.detail.consent.updatedBy === 'onAccept') {
            injectHubspot();
        } else {
          // console.log('Consent denied - not injecting HubSpot');
        }
      }
    };

    // Check if consent was already given
    if (typeof window !== 'undefined' && window.usercentricsConsent === true) {
      injectHubspot();
    }

    // Listen for future consent acceptance
    if (typeof window !== 'undefined') {
      window.addEventListener('UC_CONSENT', handleConsentAccept, { once: true });
    }
  }

  render() {
    return (<></>);
  }
}

export default Hubspot;